<!--
    EiToolingStageVisTabComponent Template

    Vertical stepper of the 7 pipeline phases with per-phase metrics.
-->

<div class="flex flex-column gap-2">
    @for (phase of allPhases; let i = $index; track phase.key) {
        <div class="flex gap-3" [ngClass]="phaseRowClass(phase)">

            <!-- Icon column -->
            <div class="flex flex-column align-items-center ei-phase-icon-col">
                <div
                        [class]="phaseCircleClass(phase)"
                        [style.backgroundColor]="phaseCircleBackground(phase)">
                    <i [class]="phaseStateIcon(phase)"></i>
                </div>
                @if (i < allPhases.length - 1) {
                    <div class="ei-phase-connector-vert mt-1"
                         [style.backgroundColor]="connectorColor(phase)"></div>
                }
            </div>

            <!-- Content column -->
            <div class="flex-1 surface-100 border-round p-3 mb-2">
                <div class="flex justify-content-between align-items-start gap-2 flex-wrap">
                    <div>
                        <div class="font-bold">{{ phaseLabel(phase) }}</div>
                        <div class="text-xs text-500">{{ phaseStateLabel(phase) }}</div>
                    </div>
                    @if (phaseTimestamp(phase); as ts) {
                        <div class="text-right">
                            <div class="text-xs text-600">Erreicht</div>
                            <div class="text-sm">{{ ts | date:'dd.MM.yyyy HH:mm:ss' }}</div>
                        </div>
                    }
                </div>

                @if (phaseMetrics(phase); as metrics) {
                    <div class="grid mt-3">
                        @for (m of metrics; track m.label) {
                            <div class="col-6 md:col-3">
                                <div class="text-xs text-600">{{ m.label }}</div>
                                <div class="font-bold">{{ m.value }}</div>
                            </div>
                        }
                    </div>
                }
            </div>

        </div>
    }
</div>
